import { action, observable, makeObservable } from 'mobx';
import { LinkOrderLineForm } from 'modules/order/forms';
import { BaseViewStore } from 'core/stores';
import { formInvalidate } from 'core/utils';
import { OrderLineStore } from 'modules/order-line/stores';
import { ProductService } from 'common/data';
import { sourceOfChange } from 'common/constants';
import _ from 'lodash';

class LinkOrderLineViewStore extends BaseViewStore {
	@observable existingProduct = false;
	@observable error = null;
	orderLine;

	form = new LinkOrderLineForm({
		onSuccess: async () => this.openConfirmationModal(this.getLinkOrderLineConfirmModalProps()),
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.orderLineStore = new OrderLineStore(rootStore);
		this.productService = new ProductService(rootStore.app.baasic.apiClient);
		this.refreshPage = modalParams.data.refreshPage;
		this.initialize(modalParams.data.orderLineId);
	}

	@action.bound
	initialize = async orderLineId => {
		this.suspend();
		await this.getOrderLine(orderLineId);
		this.resume();
	};

	@action.bound
	getOrderLine = async id => {
		this.orderLine = await this.orderLineStore.getOrderLine(id, {
			embed: ['order', 'order.channel', 'order.channel.channelType'],
		});
	};

	openCreateProductPage = () => {
		this.modalParams.close();
		this.rootStore.routerStore.goTo('master.app.main.product.list.add', {
			orderLineId: this.orderLine.id,
			orderDetailId: this.rootStore.routerStore.routerState.params.id,
			channel: this.orderLine.order.channel,
			sku: this.orderLine.sku,
			sellerId: this.orderLine.sellerId,
		});
	};

	@action.bound
	linkOrderLine = async linkAll => {
		this.suspend();
		try {
			const { product, description } = this.form.values();
			await this.orderLineStore.linkOrderLine(
				{
					id: this.orderLine.id,
					productId: product.extra.id,
					linkAll,
					description,
				},
				linkAll ? sourceOfChange.linkAllOrderLines : sourceOfChange.linkOrderLine
			);
			this.rootStore.notificationStore.success(['LINKORDERLINEVIEW.ORDERLINELINKED']);
			this.modalParams.close();
			this.rootStore.viewStore.countUnlinkedOrderLines();
			this.refreshPage();
		} catch (err) {
			if (err.data != null) {
				this.error = ['LINKORDERLINEVIEW.ERROR', { sku: err.data.mainSku }];
			} else {
				formInvalidate({ form: this.form, err });
			}
		}
		this.resume();
	};

	@action.bound
	toggleExistingProduct = () => {
		this.existingProduct = !this.existingProduct;
	};

	@action.bound
	onSelect = product => {
		if (product && product.value) {
			this.selectedProduct = product;
			this.form.$('productSku').value = product.value;
		}
	};

	getLinkOrderLineConfirmModalProps = () => {
		return {
			onConfirm: async () => await this.linkOrderLine(true),
			onCancel: async () => await this.linkOrderLine(false),
			message: ['LINKORDERLINEVIEW.LINKALLORDERLINES'],
		};
	};
}

export default LinkOrderLineViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/LinkOrderLineViewStore.js